import { environment } from "projects/Check-In/src/environments/environment";
import * as AfEnv from 'src/environments/environment';

const Controller = {
  CheckIn: `${environment.CHECKIN_API_URL}CheckIn`,
  Localization: `${AfEnv.environment.LOCALIZATION_API_URL}Localization`,
  Appointment: `${environment.CHECKIN_API_URL}Appointment`,
  RepairStatus: `${environment.CHECKIN_API_URL}RepairStatus`,
  Notification: `${environment.CHECKIN_API_URL}Notification`,
  SmsService: `${environment.CHECKIN_API_URL}SmsService`,
  Setting: `${environment.CHECKIN_API_URL}setting`,
  Document: `${environment.CHECKIN_API_URL}Document`,
  Tracker: `${environment.CHECKIN_API_URL}Tracker`,
}

export const AppConfig = Object.freeze(
  {
    // API URLS

    //check-in-data.service.ts
    GET_CHECK_IN_MODULE_DATA_URL: `${Controller.CheckIn}/Get`,
    GET_CDK_REPAIR_MODULE_DATA_URL: `${Controller.CheckIn}/GetAppointment`,
    GET_BRANDS: `${Controller.CheckIn}/GetBrandList`,
    GET_CHECK_IN_CUSTOMER_COUNT_URL: `${Controller.CheckIn}/GetCheckInCustomerCount`,
    GET_NOT_CHECK_IN_CUSTOMER_COUNT_URL: `${Controller.CheckIn}/GetNotCheckInCustomerCount`,
    POST_NOTIFICATION_URL: `${Controller.CheckIn}`,
    GET_DOCUMENT_SIGN_URL: `${Controller.Document}/GetSignUrl`,
    SENT_WARRANTY_DOC_URL: `${Controller.Document}/WarrantyDocumentSend`,

    //tiny url
    DECRYPT_TINY_URL: `${Controller.CheckIn}/Validate`,
    GET_STATUS_TRACKER_TINY_URL: `${Controller.Tracker}/Get`,
    ADD_STATUS_TRACKER_LINK: `${Controller.Tracker}/Add`,

    //customer.service.ts
    GET_CHECK_IN_STATUS: `${Controller.CheckIn}/GetCheckInStatus`,
    UPDATE_CUSTOMER_CHECK_IN_URL: `${Controller.CheckIn}/Update`,
    ADD_CUSTOMER_CONTACT_USER_DETAILS_URL: `${Controller.CheckIn}/Add`,
    ADD_CUSTOMER_ADVISE_DETAILS_URL: `${Controller.CheckIn}/AddCustomerAdviseDetails`,
    ADD_UPDATE_CUSTOMER_DETAILS_URL: `${Controller.CheckIn}/AddUpdateCustomerDetails`,
    ADD_CUSTOMER_UPLOADED_DOCUMENT: `${Controller.Document}/Upload`,

    //dealer-advice.service.ts
    GET_DEALER_ADVICE_MASTER_DATA_URL: `${Controller.CheckIn}/Services`,
    GET_DEALER_SCREEN_MASTER_VIEW_URL: `${Controller.CheckIn}/GetDealerScreenViews`,

    //localization API
    GET_COMMON_LOCALIZATION_LANGUAGE_API_URL: `${Controller.Localization}/Languages`,
    GET_ALL_LOCALIZATION_URL: `${Controller.Localization}/All`,
    GET_LOCALIZATION_DATA_FOR_ADMIN_URL: `${Controller.Localization}/Application`,
    GET_SELECTED_THEME: `${Controller.Localization}/Theme`,

    //settings API
    GetGenericSettings: `${Controller.Setting}/GetGeneric`,
    GetSettings: `${Controller.Setting}/Get`,
    GetFeature: `${Controller.Setting}/Feature`,

    //store traversal log
    STORE_TRAVERSAL_LOG_URL: `${Controller.CheckIn}/Log`,
    CALL_DEALER_LOG_ENTRY_URL: `${Controller.CheckIn}/CallLog`,
    GET_DEMANDWISE_DOCUMENT_COUNT: `${Controller.Document}/Count`,
    GET_DEMAND_DOCUMENT: `${Controller.Document}/Get`
  })
